/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CalculationParameterEntryStatus = {
    Active: 'Active',
    Future: 'Future',
    Past: 'Past'
} as const;
export type CalculationParameterEntryStatus = typeof CalculationParameterEntryStatus[keyof typeof CalculationParameterEntryStatus];


export function instanceOfCalculationParameterEntryStatus(value: any): boolean {
    for (const key in CalculationParameterEntryStatus) {
        if (Object.prototype.hasOwnProperty.call(CalculationParameterEntryStatus, key)) {
            if (CalculationParameterEntryStatus[key as keyof typeof CalculationParameterEntryStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CalculationParameterEntryStatusFromJSON(json: any): CalculationParameterEntryStatus {
    return CalculationParameterEntryStatusFromJSONTyped(json, false);
}

export function CalculationParameterEntryStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationParameterEntryStatus {
    return json as CalculationParameterEntryStatus;
}

export function CalculationParameterEntryStatusToJSON(value?: CalculationParameterEntryStatus | null): any {
    return value as any;
}

export function CalculationParameterEntryStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CalculationParameterEntryStatus {
    return value as CalculationParameterEntryStatus;
}

